/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import {
  ExtendedFlex,
  StackableCallout,
} from '../coreui';

import { CalloutsData } from './_contentData';

const Callouts = () => {
  return (
    <ExtendedFlex
      w={1}
      bg="gray.0"
      justify="center"
      pt={40}
      pb={80}
    >
      <ExtendedFlex
        w={1}
        flexDirection={['column', 'column', 'column', 'row']}
        justify="center"
        align="center"
        maxWidth={1600}
      >
        {
          CalloutsData.map(
            (callout) => {
              return (
                <ExtendedFlex
                  key={callout.header}
                  align="center"
                  flexDirection="column"
                >
                  <StackableCallout
                    w={1}
                    {...callout}
                  />
                </ExtendedFlex>
              );
            },
          )
        }
      </ExtendedFlex>
    </ExtendedFlex>
  );
};

export default Callouts;
